import EServicePartnerServiceRequest from "../containers/EServicePartnerServiceRequests/EServicePartnerServiceRequest";
import EServicePartnerDashboard from "../containers/EServicePartnerServiceRequests/EServicePartnerDashboard";
import ESPReportsContainer from "../containers/EServicePartnerServiceRequests/ESPReportsContainer";
import UploadStatusProgressionSheetContainer from "../containers/EServicePartnerServiceRequests/UploadStatusProgressionSheetContainer";
import ESPFollowUpsContainer from "../containers/EServicePartnerServiceRequests/ESPFollowUpsContainer";
import ESPSubscribersInterface from "../containers/EServicePartnerServiceRequests/ESPSubscribersInterface";
import ESPUmcInterface from "../containers/EServicePartnerServiceRequests/ESPUmcInterface";
import ESPUmcReportingInterface from "../containers/EServicePartnerServiceRequests/ESPUmcReportingInterface";
import ESPUMCFeedbackContainer from "../containers/EServicePartnerServiceRequests/ESPUMCFeedbackContainer";



export const routes = [
    {
		key: "ESP_DASHBOARD",
		path: "/service_partner/dashboard",
		component: EServicePartnerDashboard,
	},
	{
		key: "ESP_SERVICE_REQUESTS",
		path: "/service_partner/service-requests",
		component: EServicePartnerServiceRequest,
	},	
	{
		key: "ESP_REPORTS",
		path: "/service_partner/reports",
		component: ESPReportsContainer,
	},
	{
		key: "UPLOAD_STATUS_PROGREESION_SHEET_CONTAINER",
		path: "/service_partner/upload-status-progression-sheet",
		component: UploadStatusProgressionSheetContainer,
	},
	{
		key: "ESP_FOLLOW_UPS",
		path: "/service_partner/follow-ups",
		component: ESPFollowUpsContainer,
	},
	{
		key: "ESPSUBSCRIBERS_CONTAINER",
		path: "/service_partner/espsubscriber/",
		component: ESPSubscribersInterface,
	},
	{
		key: "ESPUMCSERVICES_CONTAINER",
		path: "/service_partner/espumcinterface/",
		component: ESPUmcInterface,
	},
	{
		key: "ESPUMCREPORTING_CONTAINER",
		path: "/service_partner/espumcreporting/",
		component: ESPUmcReportingInterface,
	},
	{
		key: "ESP_FEEDBACK_CONTAINER",
		path: "/service_partner/espumcfeedback/",
		component: ESPUMCFeedbackContainer,
	},


	//REPORT ROUTE.
];